import { useState, useEffect, useRef } from 'react';
import { ModuleData, ModuleType } from '@/components/filters/types';
import { MODULE_TYPES, normalizeModuleType } from '@/core/constants/moduleTypes';

interface UseSelectedModuleOptions {
    moduleId: string | null;
    moduleType: ModuleType | string;
    trolleyShelterIds?: ModuleData[];
    zoneTrackerIds?: ModuleData[];
    lineTrackerIds?: ModuleData[];
}

export const useSelectedModule = ({
    moduleId,
    moduleType,
    trolleyShelterIds = [],
    zoneTrackerIds = [],
    lineTrackerIds = []
}: UseSelectedModuleOptions): ModuleData | null => {
    const [selectedModule, setSelectedModule] = useState<ModuleData | null>(null);

    const lastIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (!moduleId) {
            if (lastIdRef.current !== null) {
                setSelectedModule(null);
                lastIdRef.current = null;
            }
            return;
        }

        const normalizedType = normalizeModuleType(moduleType);
        let allModules: ModuleData[] = [];

        switch (normalizedType) {
            case MODULE_TYPES.TROLLEY_SHELTER:
                allModules = trolleyShelterIds;
                break;
            case MODULE_TYPES.ZONE_TRACKER:
                allModules = zoneTrackerIds;
                break;
            case MODULE_TYPES.LINE_TRACKER:
                allModules = lineTrackerIds;
                break;
        }

        const found = allModules.find((m) => m.id === moduleId) ?? null;

        const foundId = found?.id ?? null;

        if (foundId !== lastIdRef.current) {
            setSelectedModule(found);
            lastIdRef.current = foundId;
        }
    }, [moduleId, moduleType, trolleyShelterIds, zoneTrackerIds, lineTrackerIds]);

    return selectedModule;
};
